export const MARKETS = {
  'Criptomoedas': [
    { symbol: 'BTCUSDT', name: 'Bitcoin' },
    { symbol: 'ETHUSDT', name: 'Ethereum' },
    { symbol: 'SOLUSDT', name: 'Solana' },
    { symbol: 'BNBUSDT', name: 'BNB' },
    { symbol: 'XRPUSDT', name: 'Ripple' },
    { symbol: 'DOGEUSDT', name: 'Dogecoin' },
    { symbol: 'ADAUSDT', name: 'Cardano' },
    { symbol: 'AVAXUSDT', name: 'Avalanche' },
    { symbol: 'LINKUSDT', name: 'Chainlink' },
    { symbol: 'DOTUSDT', name: 'Polkadot' },
    { symbol: 'SUIUSDT', name: 'SUI' },
    { symbol: 'TRXUSDT', name: 'TRON' }
  ],
  'Índices': [
    { symbol: 'US100', name: 'NASDAQ 100' },
    { symbol: 'US500', name: 'S&P 500' }
  ],
  'Ações EUA': [
    { symbol: 'AAPL', name: 'Apple Inc.' },
    { symbol: 'TSLA', name: 'Tesla Inc.' },
    { symbol: 'NVDA', name: 'NVIDIA Corp.' }
  ],
  'Forex': [
    { symbol: 'EURUSDT', name: 'EUR/USD' },
    { symbol: 'GBPUSDT', name: 'GBP/USD' },
    { symbol: 'AUDUSDT', name: 'AUD/USD' },
    { symbol: 'JPYUSDT', name: 'JPY/USD' }
  ],
  'Commodities': [
    { symbol: 'PAXGUSDT', name: 'Ouro (PAXG)' },
    { symbol: 'XAUUSDT', name: 'Ouro (XAU)' },
    { symbol: 'XAGUSDT', name: 'Prata (XAG)' }
  ]
};
